import NetUserResourcePurchasesRepository from './NetUserResourcePurchasesRepository';

export default class NetUserActorPurchasesRepository extends NetUserResourcePurchasesRepository {
  constructor() {
    super('actor');
  }
}
